import React from 'react'
import OdsOffersOverview from './OdsOffersOverview'
import { BasicWidgetProps } from '../../types'

const OdsOffers: React.FC<BasicWidgetProps> = ({ widgetId, handleConfig, readonly }: BasicWidgetProps) => {
    return (
        <div data-test="LastWeek">
            <OdsOffersOverview
                config={{ weekModifier: -1 }}
                widgetId={widgetId}
                handleConfig={handleConfig}
                readonly={readonly}
            />
        </div>
    )
}

export default OdsOffers